import Vue from "vue";
import Vuex from "vuex";

import api from "./api";

import tat_lang from "./_mock/lang/tat.json";
import ru_lang from "./_mock/lang/ru.json";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    isAuthorized: false,
    accessToken: localStorage.access || "",
    userData: null,
    userAwards: [],
    areasList: null,
    operatorOrders: [],
    operatorOrdersStatusTotal: [],
    operatorOrdersAmount: null,
    lang: "RU",
    translation: ru_lang,
  },
  mutations: {
    setToken(state, data) {
      state.isAuthorized = true;
      state.accessToken = data.access_token;
      localStorage.access = data.access_token;
    },
    removeToken(state) {
      state.isAuthorized = false;
      state.accessToken = "";
      state.userData = null;
      localStorage.access = "";
    },
    setUser(state, data) {
      state.isAuthorized = true;
      state.userData = data;
    },
    setAwards(state, data) {
      state.userAwards = data;
    },
    updateUser(state, data) {
      state.userData = data;
    },
    setAreas(state, data) {
      state.areasList = data;
    },
    setOperatorOrders(state, data) {
      state.operatorOrders = data.results;
      state.operatorOrdersStatusTotal = data.orders_status_total;
      state.operatorOrdersAmount = data.count;
    },
    setTranslationData(state, data) {
      window.localStorage.lang = data;
      if (data === "RU") {
        state.translation = ru_lang;
        state.lang = "RU";
      } else {
        state.translation = tat_lang;
        state.lang = "TAT";
      }
    },
  },
  actions: {
    getPlatforms(store) {
      return api.getMethod(store, {
        url: `/api/seating/platform/`,
      });
    },
    //all events
    getEvents(store) {
      return api.getMethod(store, {
        url: `/api/events/events/`,
      });
    },
    // future events
    getFutureEvents(store) {
      return api.getMethod(store, {
        url: `/api/events/events/?archive=false`,
      });
    },
    //current event
    getCurrentEvent(store) {
      return api.getMethod(store, {
        url: `/api/events/main`,
      });
    },
    //registration
    reg(store, data) {
      return api.authMethod(store, {
        url: `/api/users/register/`,
        data: data.userCredentials,
      });
    },
    //reset password
    changePassword(store, data) {
      const _data = data && data.data ? data.data : {};
      const _params = data && data.params ? data.params : {};
      return api.putMethod(store, {
        url: `/api/users/change-password/`,
        data: _data,
        params: _params,
      });
    },
    resetPassword(store, data) {
      return api.postMethod(store, {
        url: `/api/users/reset-password/`,
        data: data,
      });
    },
    //authorization
    auth(store, data) {
      return api.authMethod(store, {
        url: `/api/users/login/`,
        data: data.userCredentials,
        mutationType: "setToken",
      });
    },
    resendAuthLink(store, data) {
      return api.authMethod(store, {
        url: "/api/users/resend-confirmation-email/",
        data,
      });
    },
    //get user data
    getUser(store) {
      return api.getMethod(store, {
        url: `/api/users/profile/`,
        mutationType: "setUser",
      });
    },
    getUserAwards(store) {
      return api.getMethod(store, {
        url: `/api/users/award/`,
        mutationType: "setAwards",
      });
    },
    getAwardTypes(store) {
      return api.getMethod(store, {
        url: `/api/users/award-types/`,
      });
    },
    getAwardCompetition(store, id) {
      return api.getMethod(store, {
        url: `/api/users/award-types/?parent_type_id=${id}`,
      });
    },
    addAward(store, data) {
      return api.postMethod(store, {
        url: `/api/users/award/`,
        data,
      });
    },
    editAward(store, data) {
      return api.putMethod(store, {
        url: `/api/users/award/${data.id}/`,
        data,
      });
    },
    deleteAward(store, { id }) {
      return api.deleteMethod(store, {
        url: `/api/users/award/${id}`,
      });
    },
    // orders
    getOrders(store, params) {
      return api.getMethod(store, {
        url: `/api/orders/orders/`,
        params,
        mutationType: "setOperatorOrders",
      });
    },
    getOrder(store, id) {
      return api.getMethod(store, {
        url: `/api/orders/orders/${id}/`,
      });
    },
    updateOrderStatus(store, data) {
      return api.patchMethod(store, {
        url: `/api/orders/orders/${data.id}/change-status/`,
        data,
      });
    },
    updateOrderStatusBulk(store, data) {
      return api.patchMethod(store, {
        url: `/api/orders/orders/change-status-bulk/`,
        data,
      });
    },
    changeOrderStatus(store, id) {
      return api.deleteMethod(store, {
        url: `/api/orders/orders/${id}/`,
      });
    },
    // attachments
    addAttachments(store, data) {
      const _data = data || {};
      return api.postMethod(store, {
        url: `/api/attachments/upload/`,
        data: _data,
      });
    },
    getNotifications(store) {
      return api.getMethod(store, {
        url: `/api/mailing/notifications/`,
      });
    },
    //create orders
    createOrder(store, data) {
      return api.postMethod(store, {
        url: `/api/orders/orders/`,
        data: data,
      });
    },
    //profile
    updateUserProfile(store, data) {
      return api.putMethod(store, {
        url: "/api/users/profile/",
        mutationType: "updateUser",
        data: data,
      });
    },
    changeUserProfile(store, data) {
      return api.putMethod(store, {
        url: "/api/users/change-profile/",
        data: data,
      });
    },
    //areas
    getAreas(store) {
      return api.getMethod(store, {
        url: `/api/users/areas/`,
        mutationType: "setAreas",
      });
    },
    //confirm registration
    confirmRegistration(store, data) {
      return api.authMethod(store, {
        url: "/api/users/confirm-email/",
        data: data.data,
        mutationType: "setToken",
      });
    },
    //get award places
    getAwardPlaces(store) {
      return api.getMethod(store, {
        url: `/api/users/award-places/`,
      });
    },
    sendMessage(store, data) {
      return api.postMethod(store, {
        url: `/api/mailing/contact-form/`,
        data: data,
      });
    },
    getExcelOrders(store, params) {
      return api.getMethod(store, {
        url: `/api/orders/orders/export-to-excel/`,
        params,
      });
    },
  },
});
